<span class="hlf-margin-left opacity-75"><ng-content></ng-content></span>
